<mat-form-field2 class="mat-block" [showLabel]="!inline">
  <app-select
    [required]="codeCtrl | required"
    [disabled]="codeCtrl?.disabled"
    [items]="countries"
    [searchable]="true"
    [formControl]="codeCtrl"
    bindValue="id"
    bindLabel="name"
    [placeholder]="label"
    [showBlankItem]="showBlankItem"
    [multiple]="multiple"
  >
  </app-select>
</mat-form-field2>
